import { render, staticRenderFns } from "./AmbassadorWithdrawalHistory.vue?vue&type=template&id=4a1b7552&"
import script from "./AmbassadorWithdrawalHistory.vue?vue&type=script&lang=js&"
export * from "./AmbassadorWithdrawalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports